<template>
    <v-card class="ma-3 pa-5">
        <h4>Growth Phase Items</h4>
        <v-data-table
            :headers="headers"
            :items="growthPhaseItems"
            :items-per-page="20"
            :loading="loading"
            class="elevation-1"
        >
            <template v-slot:item.growth_index="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.growth_index"
                ></v-textarea>
            </template>

            <template v-slot:item.yearly_active_temperature_sum_minimum="{ item }">
                <v-text-field
                    flat
                    dense
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    type="number"
                    v-model.number="item.yearly_active_temperature_sum_minimum"
                ></v-text-field>
            </template>

            <template v-slot:item.name="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.name"
                ></v-textarea>
            </template>

            <template v-slot:item.locale.la_name="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="LA"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.la_name"
                ></v-textarea>
            </template>

            <template v-slot:item.locale.et_name="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="ET"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.et_name"
                ></v-textarea>
            </template>

            <template v-slot:item.locale.en_name="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="EN"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.en_name"
                ></v-textarea>
            </template>

            <template v-slot:item.locale.fi_name="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="FI"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.fi_name"
                ></v-textarea>
            </template>

            <template v-slot:item.locale.lt_name="{ item }">
                <v-textarea
                    rows="1"
                    flat
                    dense
                    placeholder="LT"
                    solo
                    class="ma-0 pa-0"
                    hide-details
                    row-height="15"
                    auto-grow
                    v-model="item.locale.lt_name"
                ></v-textarea>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" @click="editItem(item)">
                    mdi-content-save-outline
                </v-icon>
                <v-icon class="mr-2" @click="deleteItem(item)">
                    mdi-trash-can-outline
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'GrowthPhaseItems',
    props: {
        growthPhaseId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            headers: [
                { text: 'Growth Index', value: 'growth_index', align: 'start', sortable: false, width: '8%' },
                { text: 'ATS Min', value: 'yearly_active_temperature_sum_minimum', align: 'start', sortable: false, width: '8%' },
                { text: 'Name', value: 'name', align: 'start', sortable: false, width: '13%' },
                { text: 'LA', value: 'locale.la_name', align: 'start', sortable: false, width: '11%' },
                { text: 'ET', value: 'locale.et_name', align: 'start', sortable: false, width: '11%' },
                { text: 'EN', value: 'locale.en_name', align: 'start', sortable: false, width: '11%' },
                { text: 'FI', value: 'locale.fi_name', align: 'start', sortable: false, width: '11%' },
                { text: 'LT', value: 'locale.lt_name', align: 'start', sortable: false, width: '11%' },
                { text: 'Actions', value: 'actions', sortable: false, width: '8%' },
            ],
        }
    },
    async mounted() {
        if (!this.user || this.user.role !== 'super_admin') {
            return this.$router.push({ name: 'user-list' })
        }
        await this.loadItems()
    },
    methods: {
        ...mapActions('cultureGrowthPhase', ['fetchGrowthPhaseItems', 'updateGrowthPhaseItem', 'deleteGrowthPhaseItem']),
        async loadItems() {
            this.loading = true
            await this.fetchGrowthPhaseItems(this.growthPhaseId)
            this.loading = false
        },
        async editItem(item) {
            // Validate required fields before saving
            if (!item.growth_index || !item.growth_index.trim()) {
                return alert('Growth Index is required!')
            }
            if (!item.name || !item.name.trim()) {
                return alert('Name is required!')
            }
            await this.updateGrowthPhaseItem(item)
        },
        async deleteItem(item) {
            if (confirm('Are you sure?')) {
                await this.deleteGrowthPhaseItem(item.id)
            }
        },
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapState('cultureGrowthPhase', ['growthPhaseItems']),
    },
    watch: {
        growthPhaseId: {
            immediate: true,
            handler() {
                this.loadItems()
            },
        },
    },
}
</script>

<style scoped>
</style>
